// extracted by mini-css-extract-plugin
export default {"ganttChartContainer":"GanttChart_ganttChartContainer__eP36-"};